import { useEffect } from 'react';

export const useBeforeUnload = ({ shouldPreventUnload }: { readonly shouldPreventUnload: boolean }): void => {
    useEffect(() => {
        const onBeforeUnload = (event: BeforeUnloadEvent): void => {
            if (shouldPreventUnload) {
                event.preventDefault();
            }
        };

        globalThis.addEventListener('beforeunload', onBeforeUnload);

        return () => {
            globalThis.removeEventListener('beforeunload', onBeforeUnload);
        };
    }, [shouldPreventUnload]);
};
